import { render, staticRenderFns } from "./qsDetail.vue?vue&type=template&id=a65813c2&scoped=true&"
import script from "./qsDetail.vue?vue&type=script&lang=js&"
export * from "./qsDetail.vue?vue&type=script&lang=js&"
import style0 from "./qsDetail.vue?vue&type=style&index=0&id=a65813c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65813c2",
  null
  
)

export default component.exports